/**
 * Creates a new PersonalDosimetryController.
 * @class
 */
class PersonalDosimetryController {
    constructor($log, NavigationService) {
        this.$log = $log;
        this.NavigationService = NavigationService;
    }

    $onInit() {
        this.$log.debug('Shielding::init');
        const navConfig = this.NavigationService.getNavConfig();
        this.colorName = navConfig.colorName;
        this.icon = navConfig.icon;
    }
}

PersonalDosimetryController.$inject = ['$log', 'NavigationService'];

export const personalDosimetry = {
    controller: PersonalDosimetryController,
    template: `
        <div class="loader formHeader">
            <asset cls="color{{$ctrl.colorName}}" src="{{$ctrl.icon}}"></asset>
            <div class="color{{$ctrl.colorName}}">Coming soon...</div>
        </div>
    `
};
